const { analyticsEventBus } = require('../analytics/events');

/* eslint-disable-next-line valid-jsdoc */
/**
 * Get the AnalyticsEventBus outside the datalayer component. This is the
 * only way to access to it without duplicating requires.
 * @returns {analyticsEventBus}
 */
function getAnalyticsEventBus() {
  const { bylAnalytics = false } = window;
  if (!bylAnalytics) {
    throw new Error('Public analytics method are not available yet');
  }
  /** @type {analyticsEventBus} */
  return analyticsEventBus;
}

module.exports = getAnalyticsEventBus;
